var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27121 6.72721C5.1598 6.72721 5.05253 6.71129 4.94939 6.67946C4.84562 6.64763 4.75394 6.58396 4.67436 6.48846L0.353104 2.19109C0.225774 2.04784 0.162109 1.88072 0.162109 1.68973C0.162109 1.49873 0.233732 1.33161 0.376978 1.18836C0.520224 1.06104 0.687345 0.997369 0.878339 0.997369C1.06933 0.997369 1.23645 1.06104 1.3797 1.18836L5.27121 5.07988L9.18661 1.18836C9.31394 1.04512 9.4731 0.977315 9.66409 0.984955C9.85509 0.993232 10.0222 1.06104 10.1655 1.18836C10.3087 1.33161 10.3803 1.50255 10.3803 1.70118C10.3803 1.90046 10.3087 2.06376 10.1655 2.19109L5.86807 6.48846C5.78849 6.58396 5.69713 6.64763 5.594 6.67946C5.49022 6.71129 5.38263 6.72721 5.27121 6.72721Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.a019661c84881460016a0f1359ed99ed.svg";
export { ForwardRef as ReactComponent };